/**
 * Checks wether a given file is a pdf.
 *
 * @param file to check
 * @returns if given file is an pdf.
 */
export function isPdf(file: File) {
  return file.type.indexOf("/pdf") >= 0;
}

/**
 * converts a file to a base64 string
 *
 * @param file the file to convert
 */
export async function convertFileToB64Async(file: File): Promise<string> {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(String(reader.result));
    };
  });
}

/**
 * convert imagestring to file
 */
export async function convertUrlToFile(url: string, filename: string, mimeType: string) {
  return fetch(url)
    .then(function(res) {
      return res.arrayBuffer();
    })
    .then(function(buf) {
      return new File([buf], filename, { type: mimeType });
    });
}
